// src/components/PrivateRoute.jsx
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";

export default function PrivateRoute({ children }) {
  const [isLoading, setIsLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setAuthenticated(!!user);
      setIsLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (isLoading) return null; // or a loading spinner

  return authenticated ? children : <Navigate to="/customers/login" replace />;
}

// import { useAuthState } from "react-firebase-hooks/auth";
// import { Navigate } from "react-router-dom";
// import { auth } from "./firebase";

// export default function PrivateRoute({ children }) {
//   const [user, loading] = useAuthState(auth);

//   if (loading) return <p>Loading...</p>;
//   return user ? children : <Navigate to="/customers/login" />;
// }
